import React from "react";
import {FormControl, ControlLabel} from "react-bootstrap";
import context from "./../lib/context.js";
import ajax from "./../lib/ajax.js";
import TCDurationForm from "./tc-entry-duration/tc-duration-form.jsx";
import moment from "moment";
import immutable from "immutable";
import TCButtonPanel from "./shared/tc-button-panel.jsx";
import {browserHistory} from "react-router";

export default class HistoryTCDuration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {           
            timecardId : null,
            weekEnding : null,            
            hideButtonPanel: true,
            buttons: ""
        }   

        this.onLoadTimecardCompleted = this.onLoadTimecardCompleted.bind(this);
        this.onRecall = this.onRecall.bind(this);
    }
  

    componentDidMount() {       
    }  
    
    onRecall() {        
        let self = this;
        let newNotes = this.refs.durationForm.refs.tcSummary.getNotes().trim();
        if (newNotes == null || newNotes.length < 1) {
            context.message({
                    show :true,
                    type : "error",
                    message: <div>Notes is required</div>,
                    buttons: "ok"
                });
            return false;
        }

        context.message({
            show :true,
            type : "info",
            message: "Are you sure you want to recall this timecard?",
            buttons: "yes,no"
        }, function(button, s) {
            // s is timecardId, timecardId is set as the 3rd parameter of context.message
            if (button === "yes") {
                ajax.api()
                    .put("recall-timecard/" + s, {role: 'people', notes: newNotes})
                    .then(function(res) {                        
                        const tcWeekEnding = moment(self.state.weekEnding).endOf("week");
                        const curWeekEnding = moment().endOf("week");
                        if (tcWeekEnding.isAfter(curWeekEnding)) {
                            browserHistory.push(context.routeUrl(`people/future-tc-entry?tid=${s}`));
                        } else {
                            browserHistory.push(context.routeUrl(`people/tc-entry?tid=${s}`));
                        }
                        
                    })
                    .catch(function(err) {       
                        const data = err.response.data;
                        const msg = data.exceptionMessage || data.message;
                        context.message({
                            show :true,
                            type : "error",
                            message: <div>Error while recalling timecard.<br/>{msg}</div>,
                            buttons: "ok"
                        });
                    });                 
            }
        }, self.state.timecardId);                
    }

    onLoadTimecardCompleted(tc) {
        const clone = immutable.fromJS(this.state).toJS();
        const buttonConfig = this.prepareButtonPanel(tc);                
        clone.timecardId = tc.timecardId;
        clone.weekEnding = moment(tc.weekEnding).format("MM-DD-YYYY");
        clone.hideButtonPanel = buttonConfig.hideButtonPanel;
        clone.buttons = buttonConfig.buttons;
        this.setState(clone);        
    }

    prepareButtonPanel(tc) {

        const result = {
            hideButtonPanel: true,
            buttons : ""
        };
        if (tc) {
            if (tc.statusCode.toLowerCase() === "submitted") {
                result.hideButtonPanel = false;
                result.buttons = "recall";
            }
        }

        return result;
    }

    render() {
        const tcWeekEnding = moment(this.state.weekEnding).endOf("week");
        const curWeekEnding = moment().endOf("week");

        let hideGrid = (tcWeekEnding.isAfter(curWeekEnding));

        return(
            <div className="ap-form-container">
                <div className="container ap-top-margined">
                    <div className="row">
                        <div className="col-md-4 col-md-offset-4 text-center">
                            <ControlLabel>This timecard is for the week-ending : {this.state.weekEnding}</ControlLabel>                            
                        </div>
                    </div>
                </div>
                <TCDurationForm timecardId={this.props.params.timecardId} onNewTimecardAdded={this.onNewTimecardAdded}
                        onLoadTimecardCompleted={this.onLoadTimecardCompleted} allowEdit={false} hideGrid={hideGrid} 
                        ref="durationForm" requireNotes={this.state.hideButtonPanel == false} clockeditTcRoute={this.props.clockeditTcRoute}/>
                <TCButtonPanel buttons={this.state.buttons}
                        hidden={this.state.hideButtonPanel}
                        onRecall={this.onRecall}/>
            </div>
                );
    }
}
